<template>
  <pt-integral-goods-group-form class="pt-integral-goods-group-form__page" :is-edit="is_edit" :id="id">
  </pt-integral-goods-group-form>
</template>

<script>
import PtIntegralGoodsGroupForm from 'cps/integral-mall-manage/pt-integral-goods-group/pt-integral-goods-group-form'
export default {
  name: 'pt-integral-goods-group-form__view',
  components: {
    'pt-integral-goods-group-form': PtIntegralGoodsGroupForm
  },
  props: {
    isEdit: {
      type: [Boolean, String],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
